<template>
  <div class="rabbit-dictbiz">
    <div class="leftBox">
      <basic-container>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>业务字典列表</span>
          </div>
          <div class="clearfix">
            <avue-crud :option="optionParent" :table-loading="loading" :data="dataParent" :page="pageParent" ref="crud"
              v-model="formParent" :permission="permissionList" :before-open="beforeOpen" @row-del="rowDel"
              @row-update="rowUpdate" @row-save="rowSave" @row-click="handleRowClick" @search-change="searchChange"
              @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange"
              @size-change="sizeChange" @refresh-change="refreshChange" @on-load="onLoadParent">
              <template slot="menuLeft">
                <el-button type="danger" size="small" icon="el-icon-delete" v-if="permission.dict_delete" plain
                  @click="handleDelete">删 除
                </el-button>
              </template>
              <template slot-scope="{row}" slot="isSealed">
                <el-tag>{{row.isSealed===0?'否':'是'}}</el-tag>
              </template>
            </avue-crud>
          </div>
        </el-card>
      </basic-container>
    </div>
    <dragAdjustWidth wrapperBox="rabbit-dictbiz"></dragAdjustWidth>
    <div class="rightBox">
      <basic-container>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>[{{dictValue}}] 业务字典详情</span>
          </div>
          <div class="clearfix">
            <avue-crud :option="optionChild" :table-loading="loadingChild" :data="dataChild" :page="pageChild"
              ref="crudChild" v-model="formChild" :permission="permissionList" :before-open="beforeOpenChild"
              @row-del="rowDelChild" @row-update="rowUpdateChild" @row-save="rowSaveChild"
              @search-change="searchChangeChild" @search-reset="searchResetChild"
              @selection-change="selectionChangeChild" @current-change="currentChangeChild"
              @size-change="sizeChangeChild" @refresh-change="refreshChangeChild" @on-load="onLoadChild"
              :before-close="beforeClose">
              <template slot="menuLeft">
                <el-button type="danger" size="small" icon="el-icon-delete" v-if="permission.dict_delete" plain
                  @click="handleDelete">删 除
                </el-button>
              </template>
              <template slot-scope="{row}" slot="isSealed">
                <el-tag>{{row.isSealed===0?'否':'是'}}</el-tag>
              </template>

              <template slot="scopeTypeForm" slot-scope="{row}">
                <div>
                  <div>
                    <el-radio-group v-model="row.scopeType">
                      <el-radio :label="0">渠道</el-radio>
                      <el-radio :label="1">UID</el-radio>
                    </el-radio-group>

                  </div>

                  <div>
                    <el-form class="_rangeForm" ref="form" :model="row" label-width="120px">
                      <el-form-item label="渠道选择:" v-show="row.scopeType===0">
                        <el-radio-group v-model="row.scopeAppType" label="">
                          <el-radio :label="0">全部渠道</el-radio>
                          <el-radio :label="1">指定渠道</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item v-show="row.scopeType===1" label="UID上传:">
                        <div class="downloadTemplate">
                          <el-button :loading="loadingDownloadTemplate" size="mini" type="primary"
                            @click="downloadTemplate()">下载导入模版</el-button>
                          <span>

                            <el-upload class="_btn" :show-file-list="false" :action="actionUrl"
                              :before-upload="beforeUpload" :on-success="(response, file)=>{uploadSuccess(response, file)
                                row.scopeUids = response.data.uids 
                              }" :headers="headers" :multiple="false">
                              <el-button size="small" type="primary">上传</el-button>
                            </el-upload>
                          </span>
                          <el-button size="mini" type="primary" @click="()=>{delUidBtn(); row.scopeUids=[]}">删除已上传列表
                          </el-button>
                        </div>
                        <div>
                          <el-button type="text" class="_rangeForm_text" @click="downloadTemplate(row.id)">{{
                          uploadData.name || row.uidsFileName }}</el-button>
                          <span class="_rangeForm_text">成功上传{{uploadData.successNum}}</span>
                          <span class="_rangeForm_text">失败{{uploadData.failNum}}</span>
                        </div>
                      </el-form-item>
                    </el-form>
                    <el-input style=" margin-top: 20px;" v-show="row.scopeAppType==1 && row.scopeType===0"
                      type="textarea" @focus="handleClick(row.scopeApps)" v-model="row.scopeAppNames"></el-input>
                  </div>
                  <channel-popups :UrlConfig="getAllChannelsAs" :app-id="scopeApps" :visible.sync="showPopups" @comfirm="(data)=>{
                    row.scopeAppNames= data.channel
                    row.scopeApps= data.appId
                  }"></channel-popups>
                </div>
              </template>

            </avue-crud>
          </div>
        </el-card>
      </basic-container>
    </div>
  </div>
</template>

<script>
import {
  getParentList,
  getChildList,
  remove,
  update,
  add,
  getDict
} from "@/api/system/dictbiz";
import { optionParent, optionChild } from "./const/dictbiz";
import { mapGetters, mapActions } from "vuex";
import { getAllChannels } from '@/api/runActivityManage/activity';
import ChannelPopups from '@/components/channel-popups';
import axios from 'axios'
import { getToken } from '@/util/auth'
import dragAdjustWidth from '@/components/dragAdjustWidth'

export default {
  components: {
    ChannelPopups,
    dragAdjustWidth
  },
  data() {
    return {
      scopeApps: '',
      headers: {},
      uploadData: {
        name: '',
        successNum: 0,
        failNum: 0
      },
      actionUrl: process.env.VUE_APP_BASE_URL + '/lebo-system/dict-biz/uploadUids',
      loadingDownloadTemplate: false,
      showPopups: false,
      rangeRadio: 1,
      channelForm: {},
      getAllChannelsAs: getAllChannels,
      dictValue: '暂无',
      parentId: -1,
      formParent: {},
      formChild: {},
      selectionList: [],
      query: {},
      loading: true,
      loadingChild: true,
      pageParent: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      pageChild: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      dataParent: [],
      dataChild: [],
      optionParent: optionParent,
      optionChild: optionChild,
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.rabbit_dictbiz_add, false),
        delBtn: this.vaildData(this.permission.rabbit_dictbiz_delete, false),
        editBtn: this.vaildData(this.permission.rabbit_dictbiz_edit, false),
        viewBtn: false,
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  mounted() {
    this.headers = { 'Lebo-Auth': 'bearer ' + getToken() }
  },
  methods: {
    ...mapActions('runActivityManage', ['clearDicts']),
    // 弹框关闭前 清除数据
    beforeClose(done) {
      this.uploadData = {
        name: '',
        successNum: 0,
        failNum: 0
      }
      this.channelForm = {}
      done();
    },
    // 打开渠道选择框前
    handleClick(id) {
      console.log('打开渠道选择框前',id)
      this.scopeApps = Array.isArray(id) ? id.join() : id || ''
      this.showPopups = true
    },
    // 删除uid列表 
    delUidBtn() {
      this.uploadData = {
        name: '',
        successNum: 0,
        failNum: 0
      }
    },
    //上传后接口返回
    uploadSuccess(response, file) {
      if (response.code != 200) {
        this.$message({
          type: "error",
          message: "文件读取失败，请注意模板格式!"
        });
      }
      this.uploadData = {
        name: file.name,
        successNum: response.data.successNum,
        failNum: response.data.failNum,
        uids: response.data.uids
      }
    },
    // 上传前校验
    beforeUpload(file) {
      const isxlsx = (/.xlsx|.xls/).test(file.name);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isxlsx) {
        this.$message.error('上传文件只能是 xlsx格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传大小不能超过 5MB!');
      }
      return isxlsx && isLt5M;
    },
    // 下载uids模板
    downloadTemplate(id = '') {
      this.loadingDownloadTemplate = true
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + `/lebo-system/dict-biz/exportUids?id=${id}`,
        responseType: 'blob'
      }).then(res => {
        console.log(res)
        var blob = res.data//blob对象
        var reader = new FileReader();
        reader.readAsDataURL(blob)
        this.loadingDownloadTemplate = false
        reader.onload = function (e) {
          const a = document.createElement('a')
          a.download = 'UID-excel.xlsx'
          a.href = e.target.result
          a.click()
        }
      }).catch(() => {
        this.loadingDownloadTemplate = false
      })
    },
    rowSave(row, done, loading) {
      const form = {
        ...row,
        dictKey: -1,
      };
      add(form).then(() => {
        this.onLoadParent(this.pageParent);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(() => {
        this.onLoadParent(this.pageParent);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    handleRowClick(row) {
      this.parentId = row.id;
      this.dictValue = row.dictValue;
      this.$refs.crudChild.value.code = row.code;
      this.$refs.crudChild.value.parentId = row.id;
      this.$refs.crudChild.option.column.filter(item => {
        if (item.prop === "code") {
          item.value = row.code;
        }
        if (item.prop === "parentId") {
          item.value = row.id;
        }
      });
      this.onLoadChild(this.pageChild);
    },
    searchReset() {
      this.query = {};
      this.onLoadParent(this.pageParent);
    },
    searchChange(params, done) {
      this.query = params;
      this.pageParent.currentPage = 1;
      this.onLoadParent(this.pageParent, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDict(this.formParent.id).then(res => {
          this.formParent = res.data.data;
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.pageParent.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.pageParent.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoadParent(this.pageParent, this.query);
    },
    rowSaveChild(row, done, loading) {
      let params = row
      if (params.scopeApps && !Array.isArray(params.scopeApps)) {
        params.scopeApps =params.scopeApps.split(',')
      }else{
        params.scopeApps = params.scopeApps || []
      }
      if (this.uploadData.name) {
        params.uidsFileName = this.uploadData.name
      }

      add(params).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdateChild(row, index, done, loading) {
      let params = row
      if (params.scopeApps && !Array.isArray(params.scopeApps)) {
        params.scopeApps =params.scopeApps.split(',')
      }else{
        params.scopeApps = params.scopeApps || []
      }
      if (this.uploadData.name) {
        params.uidsFileName = this.uploadData.name
      }
      update(params).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDelChild(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    searchResetChild() {
      this.query = {};
      this.onLoadChild(this.pageChild);
    },
    searchChangeChild(params, done) {
      this.query = params;
      this.pageChild.currentPage = 1;
      this.onLoadChild(this.pageChild, params);
      done();
    },
    selectionChangeChild(list) {
      this.selectionList = list;
    },
    selectionClearChild() {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    handleDeleteChild() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crudChild.toggleSelection();
        });
    },
    beforeOpenChild(done, type) {
      if (["edit", "view"].includes(type)) {
        getDict(this.formChild.id).then(res => {
          this.formChild = res.data.data;
        });
      }
      done();
    },
    currentChangeChild(currentPage) {
      this.pageChild.currentPage = currentPage;
    },
    sizeChangeChild(pageSize) {
      this.pageChild.pageSize = pageSize;
    },
    refreshChangeChild() {
      this.onLoadChild(this.pageChild, this.query);
    },
    onLoadParent(page, params = {}) {
      params.dictValue = "waterrabbit";
      this.loading = true;
      getParentList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      ).then(res => {
        const data = res.data.data;
        this.pageParent.total = data.total;
        this.dataParent = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    onLoadChild(page, params = {}) {
      this.loadingChild = true;
      getChildList(
        page.currentPage,
        page.pageSize,
        this.parentId,
        Object.assign(params, this.query)
      ).then(res => {
        const data = res.data.data;
        this.pageChild.total = data.total;
        this.dataChild = data.records;
        this.loadingChild = false;
        this.selectionClear();
      });
    }
  }
};
</script>
<style lang="scss" scoped >
._rangeForm {
  margin-left: -120px;

  ._rangeForm_text {
    margin-right: 30px;
  }
}

.rabbit-dictbiz {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.leftBox {
  width: 500px;
}
.rightBox {
  flex: 1;
}

.downloadTemplate {
  display: flex !important;
  width: 330px;
  justify-content: space-between;
}
</style>